import { Observable } from "rxjs";
import { BenefitEndpoints } from "src/domains/benefits/discounts/constants/endpoints";
import { inject, injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { HttpClient } from "src/infra/http/client";
import { Environment } from "src/libs/environment";
import { replaceString } from "src/libs/replace-string";

@injectable()
export class BenefitDiscountsRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getDiscounts(
        businessLine: string,
        userIdentity: string
    ): Observable<Array<object>> {
        return this.http.getJSON<Array<Record<string, unknown>>>(
            BenefitEndpoints.GetDiscounts,
            {
                host: this.http.msHostEnv,
                customHeader: {
                    ...this.http.httpUtils.getBaseHeaders(),
                    ...this.http.httpUtils.getMsBaseHeaders(userIdentity, ""),
                },
            }
        );
    }

    @autoBind
    getEstablishments(
        discountId: number,
        userIdentity: string
    ): Observable<Array<object>> {
        const url = replaceString(BenefitEndpoints.GetEstablishments, {
            ":discountId": discountId,
        });
        return this.http.getJSON<Array<Record<string, unknown>>>(url, {
            host: Environment.string("APIMGMT_URL"),
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...this.http.httpUtils.getMsBaseHeaders(userIdentity, ""),
            },
        });
    }
}
